const replaceAccent = ( str ) => {
  const accents = 'àáâãäçèéêëìíîïñòóôõöùúûüýÿÀÁÂÃÄÇÈÉÊËÌÍÎÏÑÒÓÔÕÖÙÚÛÜÝ'
  const noAccents = 'aaaaaceeeeiiiinooooouuuuyyAAAAACEEEEIIIINOOOOOUUUUY'
  
  if ( typeof str !== 'string' ) return ''
  return str
    ?.split('')
    ?.map((char, idx) => (accents?.includes(char) ? noAccents[accents.indexOf(char)] : char))
    ?.join('')
}

export default replaceAccent